import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import deCommon from './locales/de/common.json'
import enCommon from './locales/en/common.json'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    debug: false,
    interpolation: { escapeValue: false },
    resources: {
      de: { common: deCommon },
      en: { common: enCommon },
    },
    ns: ['common'],
    defaultNS: 'common',
    detection: {
      // querystring first: a direct link like /portal/login?lang=en forces the
      // language (and caches it to localStorage so it sticks after login).
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'nc-language',
      caches: ['localStorage'],
    },
  })

export default i18n
